export const en = {
  home: {
    download: {
      ios: 'Download on the App Store',
      iosSubtitle: 'iPhone & iPad',
      cta: 'Get',
    },
    location: {
      useMyLocation: 'Use my location',
      modalBadge: 'Location',
      modalTitle: 'Choose a city',
      tabs: {
        cities: 'Cities',
        coords: 'Coordinates',
      },
      searchPlaceholder: 'Search city…',
      refresh: 'Refresh',
      loading: 'Loading cities…',
      empty: 'No cities found.',
      loadError: 'Could not load cities. Please try again.',
      scrollMore: 'Scroll to load more…',
      coords: {
        latitude: 'Latitude',
        longitude: 'Longitude',
        timezone: 'Timezone (optional)',
        latPlaceholder: 'e.g. 43.8563',
        lngPlaceholder: 'e.g. 18.4131',
        tzPlaceholder: 'e.g. Europe/Sarajevo',
        tzHint: 'If empty, we will use your device timezone.',
        apply: 'Use coordinates',
        clear: 'Clear',
        invalidLat: 'Latitude must be between -90 and 90.',
        invalidLng: 'Longitude must be between -180 and 180.',
      },
    },
    header: {
      brand: 'Deenly',
      login: 'Log In',
      downloadApp: 'Download App',
      prayers: {
        fajr: 'Fajr',
        dhuhr: 'Dhuhr',
        asr: 'Asr',
        maghrib: 'Maghrib',
        isha: 'Isha',
      },
    },
    hero: {
      badge: 'Huge Update 2.0',
      titleLine1: 'Your Complete',
      titleGradient: 'Deen, Reimagined.',
      subtitle:
        'From an ultimate scholarly feed and AI-powered Tajweed to AR Kaaba mapping, live Khutbah translations, and a PIN-protected Kids Mode. Everything you need.',
    },
    nextPrayer: {
      label: 'Next Prayer',
      statusOnTime: 'On Time',
      startsIn: 'Starts in',
      meta: {
        locationLabel: 'Sarajevo',
        methodLabel: 'MWL Calculation',
        alertsOn: 'Alerts On',
        alertsOff: 'Alerts Off',
      },
    },
    podcast: {
      badge: 'SCHOLAR PODCAST',
      titlePrefix: 'Book Explanation:',
      titleMain: 'Riyad as-Salihin',
      author: 'Sheikh Mufti Menk',
    },
    features: {
      title: 'Everything you need.',
      subtitle: 'Beautifully crafted tools for reading, listening, tracking, and daily worship.',
      core: {
        dynamicFeed: {
          title: 'Dynamic Feed',
          body: 'Books, pages, Hadiths, daily Ayahs, and podcasts explaining classical texts.',
          bookAddedLabel: 'Book Added',
          bookAddedValue: 'Sealed Nectar',
          podcastLabel: 'Podcast',
          podcastValue: 'Tafseer Ibn Kathir',
        },
        mosqueNavigator: {
          badge: 'Live Nav',
          title: 'Smart Mosque Navigator',
          body:
            "World-class turn-by-turn navigation guiding you to the nearest mosque. Choose your preferred Masjid, track ETA, and never miss Jama'ah.",
          cardTitle: 'Central Mosque',
          cardMeta: 'ETA: 5 mins • Walk',
        },
        dreamInterpreter: {
          title: 'AI Dream Interpreter',
          body: 'Understand your dreams through an Islamic lens with our AI trained on classical texts.',
          cta: 'Ask now',
        },
        libraryStats: {
          title: 'Smart Library & Stats',
          body:
            "Read the Quran seamlessly. Long-press any Ayah to bookmark it or open the Tajweed modal to read aloud and get instant AI pronunciation feedback. Use the interactive slider to calculate exactly when you'll complete the Quran.",
          chips: {
            pages: 'Pages',
            bookmarks: 'Bookmarks',
            tajweedCheck: 'Tajweed Check',
          },
          paceLabel: 'Daily Pace',
          paceValue: '20 Ayahs',
          finishLabel: 'Finish Quran in',
          finishValue: '105 Days',
          longPressLabel: 'Long Press',
          longPressValue: 'Ayah 255',
        },
      },
      premium: {
        badge: 'Ultimate Collection',
        title: 'Premium Islamic Tools',
        subtitle: 'A complete suite of highly capable tools for every Muslim.',
        arQibla: {
          title: 'AR Qibla & Kaaba',
          body:
            'Locate the exact direction of the Qibla using advanced AR. Place a virtual Kaaba right in front of you for a truly immersive experience.',
          cta: 'Open AR View',
        },
        postureGuide: {
          title: 'Posture Guide',
          body:
            'Set your phone down facing you. Our AI detects your movements and guides your prayer postures perfectly.',
        },
        liveKhutbah: {
          title: 'Live Khutbah',
          body:
            "Attending Jumu'ah abroad? Get real-time AI translation of the Imam's sermon directly on your screen.",
        },
        tajweed: {
          title: 'AI Quran Recitation',
          body:
            'Practice your recitation. The AI listens to your Tajweed and instantly highlights areas for improvement with precise feedback.',
        },
        essentials: {
          title: 'Essential Daily Tools',
          body:
            'Everything else you need: A Halal barcode scanner for ingredients, a classic Tap Tasbih, and an accurate Zakat calculator.',
          halalScanner: 'Halal Scanner',
          tapTasbih: 'Tap Tasbih',
          zakat: 'Zakat Calculator',
        },
      },
    },
    kids: {
      badge: 'Deenly Kids',
      title: 'A safe, beautiful space for your little ones.',
      subtitle:
        'Everything your child needs to learn and sleep peacefully, securely locked behind a parental PIN code.',
      items: {
        pictureBooks: {
          title: 'Picture Books',
          body: 'Interactive, beautifully illustrated visual stories that teach core Islamic values and morals.',
        },
        lullabies: {
          title: 'Halal Lullabies (No Music)',
          body: 'Calming vocals specifically recorded for babies to fall asleep peacefully. Strictly music-free.',
        },
        whiteNoise: {
          title: 'White Noise & Sleep Sounds',
          body: 'A selection of soothing ambient nature sounds and white noise designed to help them rest.',
        },
        games: {
          title: 'Interactive Games',
          body: 'Engaging, safe, and entirely educational mini-games tailored perfectly for younger children.',
        },
        pin: {
          title: 'PIN Secure Mode',
          badge: 'Locked In',
          body: 'Children are locked inside the safe Kids environment. They cannot exit without your parental PIN.',
        },
      },
    },
    cta: {
      title: 'Start your journey today.',
      subtitle: 'Join millions of Muslims worldwide building better daily habits with Deenly.',
      ios: 'Download for iOS',
      android: 'Get it on Android',
    },
    footer: {
      copyright: '© 2023 Deenly. All rights reserved.',
      links: {
        privacy: 'Privacy Policy',
        terms: 'Terms of Service',
        contact: 'Contact',
      },
    },
  },
  legal: {
    privacy: {
      metaTitle: 'Privacy & Terms • Deenly',
      header: {
        badge: 'Legal Document',
        back: 'Back',
      },
      hero: {
        titlePrefix: 'Privacy ',
        titleGradient: 'Policy.',
        subtitle:
          "We believe your data is your business, not ours. Our core philosophy is to collect as little as possible while delivering a world-class experience.",
        lastUpdatedLabel: 'Last updated',
        badgeIcon: 'solar:shield-check-linear',
        calendarIcon: 'solar:calendar-linear',
      },
      languageLabel: 'Language',
      lang: {
        en: 'English',
        bs: 'Bosanski',
      },
      search: {
        title: 'Search',
        placeholder: 'Search (e.g. “data”, “account”, “third parties”)',
        found: 'Sections found',
        clear: 'Clear',
        tocTitle: 'Contents',
        tocHint: 'Jump to a section.',
        emptyTitle: 'No results',
        emptyBody:
          'No sections match your search. Try a different keyword.',
        backToTop: 'Back to top',
        backHome: 'Back home',
      },
      tldr: {
        title: 'The TL;DR',
        icon: 'solar:bolt-linear',
        cards: [
          {
            icon: 'solar:eye-closed-linear',
            title: 'No Ads, Ever',
            body: "We don't sell your data to advertisers. Sustained entirely by premium subscriptions.",
          },
          {
            icon: 'solar:map-point-linear',
            title: 'Local Location',
            body: 'Prayer times calculate directly on your device. We never track your movements.',
          },
          {
            icon: 'solar:lock-keyhole-minimalistic-linear',
            title: 'Encrypted Sync',
            body: 'Your bookmarks and personal stats are encrypted in transit and at rest.',
          },
          {
            icon: 'solar:smile-circle-linear',
            title: 'Kids Are Safe',
            body: 'Kids Mode complies with COPPA and collects absolutely zero telemetry.',
          },
        ],
      },
      toc: [
        { id: 'tldr', label: 'The TL;DR' },
        { id: 'collection', label: 'Collection' },
        { id: 'usage', label: 'Data Usage' },
        { id: 'kids', label: 'Kids Privacy' },
        { id: 'sharing', label: 'Sharing' },
        { id: 'security', label: 'Security' },
        { id: 'contact', label: 'Contact Us' },
      ],
      collection: {
        title: 'Information We Collect',
        intro:
          'We are committed to minimal data collection. Here is exactly what happens when you use Deenly.',
        items: [
          {
            icon: 'solar:key-minimalistic-2-linear',
            title: 'Device Identity (UUID)',
            bodyParts: [
              { text: 'On first launch, the app generates a random ', highlight: false },
              { text: 'UUID', highlight: true },
              { text: ' and stores it securely in your device session (Keychain / Keystore). This identifier is used solely to register your device with our servers. It never leaves the device except to authenticate with our API.', highlight: false },
            ],
          },
          {
            icon: 'solar:lock-keyhole-minimalistic-linear',
            title: 'Session Token (JWT)',
            bodyParts: [
              { text: 'After registration, our server issues a ', highlight: false },
              { text: 'JWT', highlight: true },
              { text: ' that is stored exclusively in your device session. All subsequent API requests use this token. There is no traditional username/password login — your identity is your device session.', highlight: false },
            ],
          },
          {
            icon: 'solar:routing-2-linear',
            title: 'Location Data (On-Device)',
            bodyParts: [
              { text: 'Required solely to calculate accurate prayer times and Qibla direction. Calculation happens ', highlight: false },
              { text: 'locally on your device', highlight: true },
              { text: '. We never store or transmit your location history.', highlight: false },
            ],
          },
          {
            icon: 'solar:mic-2-linear',
            title: 'Microphone Access',
            body:
              'Used for the AI recitation checker and the Live Khutbah translation. Speech recognition runs on your device — the audio itself is never uploaded, recorded, or stored by us. What may leave the device is text, described below.',
          },
          {
            icon: 'solar:document-text-linear',
            title: 'AI Text Processing (Transcripts & Dreams)',
            bodyParts: [
              { text: 'Some AI features need more computing power than a phone has. When you use the Live Khutbah translation, the recognized ', highlight: false },
              { text: 'text of each sentence', highlight: true },
              { text: ' (never the audio) is sent over an encrypted connection to our servers and passed to a trusted AI processing partner to produce the translation and the end-of-khutbah summary. Dream descriptions you submit to the Interpreter are processed the same way. These requests carry only your device session — not your name or contact details. Your khutbah history is stored only on your device; translations are cached on our servers for up to 30 days so a whole congregation following the same khutbah is served instantly; shared "room" transcripts are deleted from our servers within a few hours.', highlight: false },
            ],
          },
        ],
      },
      usage: {
        title: 'How We Use Data',
        intro:
          'Any data we do collect is utilized strictly to improve your experience. We do not engage in behavioral profiling.',
        cards: [
          {
            icon: 'solar:cloud-sync-linear',
            title: 'Cloud Synchronization',
            body:
              'Seamlessly synchronize your Quran bookmarks, daily stats, and settings across your devices.',
          },
          {
            icon: 'solar:magic-stick-3-linear',
            title: 'AI Features Processing',
            body:
              'Sentence-by-sentence khutbah translation, khutbah summaries, and dream interpretations are produced from text sent to our servers and a trusted AI processing partner. Requests are tied to your device session only and are never used to build a profile of you.',
          },
        ],
      },
      kids: {
        title: 'Kids Mode Privacy',
        intro:
          'We take the privacy of minors extraordinarily seriously. The kids section is a highly secure, offline-first environment.',
        badge: {
          icon: 'solar:star-fall-minimalistic-2-linear',
          label: 'Special Provision',
        },
        items: [
          {
            icon: 'solar:shield-check-linear',
            text: 'Zero tracking or analytics scripts in Kids Mode.',
          },
          {
            icon: 'solar:document-text-linear',
            text: 'Fully COPPA and GDPR-K compliant.',
          },
          {
            icon: 'solar:lock-password-linear',
            text: 'No external links or purchases without Parental PIN.',
          },
        ],
      },
      sharing: {
        title: 'Data Sharing',
        body:
          'We do not sell, rent, or trade your personal information to third parties. We only share information with highly trusted infrastructure partners solely for the purpose of operating the application — including an AI processing partner that receives only the text needed to deliver a feature (a khutbah sentence to translate, a dream description to interpret), never your identity. These partners are bound by strict confidentiality agreements and may not use your data for their own purposes, including advertising or training on your content.',
      },
      security: {
        title: 'Security Measures',
        body:
          'Your trust is our greatest asset. We implement state-of-the-art security measures to protect your data. All communication is secured using TLS encryption. Your UUID and JWT are stored only in your device\'s secure session (Keychain on iOS, Keystore on Android) and are never accessible outside your device.',
      },
      contactCta: {
        title: 'Privacy Concerns?',
        subtitle: 'Our privacy team is ready to help you.',
        button: 'Contact Privacy Team',
        icon: 'solar:letter-linear',
      },
      footerNote: 'All rights reserved. Designed with pure intentions.',
      footer: {
        links: {
          terms: 'Terms',
          privacy: 'Privacy',
          cookies: 'Cookies',
        },
      },
    },
  },
};

